import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import async from 'async';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-remove-collaborator.hbs';

    var RevokeCollaborationDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        id: 'remove-collaborator-dialog',
        ui: {
            removeButton: 'button[type="submit"]'
        },
        events: {
            'click @ui.removeButton': 'onClickRemove',
        },
        initialize: function(options) {
            this.destroyOnClose();
            this.active_account = options.active_account;
        },
        removeAllGrants: function() {
            var grantsToDestroy = this.model.grants().filter(function(grant) {
                return grant.rel.get('grantee').id === this.active_account.id;
            }, this);
            async.each(grantsToDestroy, _.bind(function(grant, cb) {
                grant.destroy({
                    success: function() {
                        cb();
                    },
                    error: function(model, response) {
                        cb(response);
                    }
                });
            }, this),
            _.bind(function(err) {
                if (err) {
                    Radio.request('alerts', 'showAlert', {
                        message: 'Removing one or more roles failed: ' + err.responseJSON.errors[0].title,
                        messageType: 'danger'
                    });
                }
                this.closeDialog();
                Radio.request('global', 'memberships');
            }, this));
        },
        onClickRemove: function(e) {
            e.preventDefault();
            // Disable submit button to avoid sending multiple requests
            this.ui.removeButton.prop('disabled', true);
            this.removeAllGrants();
        }
    });
    export default RevokeCollaborationDialog;

